import { kioskAgent } from './kiosk-agent';

export interface KioskPairingRequestCreatedResponse {
  requestId: string;
  expiresAt: string;
  pollIntervalMs: number;
}

type KioskPairingStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXPIRED' | 'CANCELLED';

export interface KioskPairingRequestPollResponse {
  status: KioskPairingStatus;
  deviceToken?: string;
  companyId?: string;
  companyName?: string;
  officeId?: number;
  officeLabel?: string;
}

interface KioskSessionResponse {
  companyName: string;
  officeId: number;
  officeLabel: string;
}

export enum KioskVisitorSignInState {
  NONE = 'NONE',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
}

export interface KioskVisitor {
  id: number;
  visitorName: string;
  companyName: string;
  timeDueHours: number;
  timeDueMinutes: number;
  signInState: KioskVisitorSignInState;
  checkedInTime: string | null;
  checkedOutTime: string | null;
  // Present only when the visitor was added to a meeting room booking. Times are UTC ISO strings.
  meetingRoomName?: string | null;
  meetingStartDateTime?: string | null;
  meetingEndDateTime?: string | null;
}

export interface KioskAddVisitorRequest {
  visitorName: string;
  companyName: string;
  email?: string;
  dueInHours?: number;
  dueInMinutes?: number;
  signInOnArrival: boolean;
}

export function createPairingRequest(code: string): Promise<KioskPairingRequestCreatedResponse> {
  return kioskAgent.post('/api/kiosk/pair', { code });
}

export function pollPairingRequest(requestId: string): Promise<KioskPairingRequestPollResponse> {
  return kioskAgent.post('/api/kiosk/pair/poll', { requestId });
}

export function cancelPairingRequestOnServer(requestId: string): Promise<void> {
  return kioskAgent.post('/api/kiosk/pair/cancel', { requestId });
}

function getKioskSession(): Promise<KioskSessionResponse> {
  return kioskAgent.get('/api/kiosk/session');
}

export function getKioskVisitorsForToday(): Promise<KioskVisitor[]> {
  return kioskAgent.get('/api/kiosk/visitors');
}

export function addKioskVisitor(request: KioskAddVisitorRequest): Promise<KioskVisitor> {
  return kioskAgent.post('/api/kiosk/visitors', request);
}

export function signInKioskVisitor(id: number): Promise<KioskVisitor> {
  return kioskAgent.post(`/api/kiosk/visitors/${id}/sign-in`);
}

export function signOutKioskVisitor(id: number): Promise<KioskVisitor> {
  return kioskAgent.post(`/api/kiosk/visitors/${id}/sign-out`);
}

export function unpairKiosk(): Promise<void> {
  return kioskAgent.post('/api/kiosk/unpair');
}
